<template>
  <div>
    <ImageCarouselAbout />
  </div>
</template>

<script>
import ImageCarouselAbout from './ImageCarouselAbout.vue';

import { useHead } from '@vueuse/head';




export default {
  name: 'AboutPage',
  components: {
    ImageCarouselAbout
  },
  setup() {
    useHead({
      title: 'O nas',
      meta: [
        {
          name: 'description',
          content: 'Poznaj Cocktail Service: doświadczenie, zaplecze i standard pracy przy obsłudze eventów oraz wynajmie sprzętu barowego w Warszawie i całej Polsce.'
        },
        {
          name: 'keywords',
          content: 'o nas cocktail service, obsługa barmańska, wypożyczalnia sprzętu barowego, eventy, Warszawa'
        },
        {
          name: 'robots',
          content: 'index, follow'
        },
        {
          property: 'og:title',
          content: 'O nas | Cocktail Service'
        },
        {
          property: 'og:description',
          content: 'Zobacz, jak Cocktail Service realizuje eventy i wynajem sprzętu barowego na terenie całej Polski.'
        },
        {
          property: 'og:image',
          content: 'https://www.cocktailservice.pl/img/O-NAS-1.webp'
        },
        {
          property: 'og:image:alt',
          content: 'Zespół Cocktail Service podczas realizacji eventu'
        },
        {
          property: 'og:url',
          content: 'https://www.cocktailservice.pl/about'
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:title',
          content: 'O nas | Cocktail Service'
        },
        {
          name: 'twitter:description',
          content: 'Doświadczenie i standard pracy Cocktail Service przy eventach i wynajmie sprzętu barowego.'
        },
        {
          name: 'twitter:image',
          content: 'https://www.cocktailservice.pl/img/O-NAS-1.webp'
        },
        {
          name: 'twitter:image:alt',
          content: 'Cocktail Service - realizacja eventowa'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.cocktailservice.pl/about'
        }
      ]
    });
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  height: 100%;
}
</style>